import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Link } from 'react-router-dom';


const Hero = () => {
    return (
        <>
            <div className="hero" id='hero'>
                <div>
                    <NavBar />
                </div>

                <div className="min-h-screen flex items-center ">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                            <div className="w-full lg:w-1/2 order-2 lg:order-1" data-aos="fade-right">
                                <h1 className="font-heading text-heading xs:text-[1.25rem] xsm:text-[1.5rem] sm:text-[1.75rem] md:text-[2rem] lg:text-[2rem] xl:text-[2rem] text-primary font-bold mb-4">
                                    Transforming Ideas into Digital Reality
                                </h1>
                                <p className="font-subheading text-subheading xs:text-[1rem] xsm:text-[1.25rem] sm:text-[1.5rem] md:text-[1.5rem] lg:text-[1.5rem] xl:text-[1.5rem] text-greyText mb-8">
                                    We build innovative software solutions that drive business growth and digital transformation.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <Link 
                                        to="/contact#contact" 
                                        className="bg-primary hover:bg-greyText text-secondary px-6 py-3 rounded-lg font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem] transition-all duration-300"
                                    >
                                        Get Started
                                    </Link>
                                    <a href="#services" className="border border-primary text-primary hover:bg-primary hover:text-secondary px-6 py-3 rounded-lg font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem] transition-all duration-300">
                                        Our Services
                                    </a>
                                </div>
                            </div>
                            <div className="w-full lg:w-2/3 order-1 lg:order-2" data-aos="fade-left">
                            <DotLottieReact
      src="https://lottie.host/cbbbf796-8568-43c7-abda-023cc96e55df/w537PANkZo.lottie"
      autoplay
      loop
      className='w-full aspect-[4/4] max-h-[450px]'
    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Hero;